module.exports = __webpack_public_path__ + "img/Marquee-11.f859fb49.jpg";